import React from "react";
import { observer } from "mobx-react";
import EsriMap from "./EsriMap";
import WidgetContainer from "./WidgetContainer";
import OnMapWidgetContainer from "./OnMapWidgetContainer";
import RootStore from "../stores/RootStore";
import { styled } from "@mui/material/styles";
// const openCloseSpeed = "0.8s";

const widgetContainerStyle = {
  position: "absolute",
  top: 0,
  bottom: 0,
  height: "100%",
  // transition: `width ${openCloseSpeed}`,
  // [theme.breakpoints.down("xs")]: {
  //   top: 56 + "px",
  // },
};

const WidgetContainerLeft = styled((props) => <WidgetContainer direction={"left"} {...props} />)({
  ...widgetContainerStyle,
  left: 0,
});

const WidgetContainerRight = styled((props) => <WidgetContainer direction={"right"} {...props} />)({
  ...widgetContainerStyle,
  right: 0,
});

const StyledMap = styled(EsriMap)({
  position: "absolute",
  top: 0,
  bottom: 0,
  borderRight: "1px solid #bbbbbb",
});

const MainArea = observer((props) => {
  const {
    bottomBarHeight,
    mapLeft,
    mapRight,
    isReady,

    BBStore: { mobile },
    subUiStores: { left: leftStore, right: rightStore },
  } = RootStore.uiStore;
  const activeWidget = leftStore?.activeWidgetId || rightStore?.activeWidgetId;
  const fullscreen = activeWidget && mobile;

  return (
    <div
      style={{
        position: "absolute",
        top: fullscreen ? 0 : 54,
        left: 0,
        right: 0,
        bottom: fullscreen ? 0 : bottomBarHeight,
        overflow: "hidden",
        zIndex: fullscreen ? 2 : -1,
      }}
    >
      <StyledMap
        style={{ right: mobile ? 0 : mapRight, left: mobile ? 0 : mapLeft }}
      >
        {isReady && <OnMapWidgetContainer></OnMapWidgetContainer>}
      </StyledMap>

      {isReady && (
        <>
          <WidgetContainerRight
            mobile={mobile}
          />
          <WidgetContainerLeft
            mobile={mobile}
          />
        </>
      )}
    </div>
  );
});

export default MainArea;
